/* @ngInject */
const movementIcons = () => {
  const self = {}

  self.id = ''
  self.wagonId = 'train'
  self.wagon = 'train'
  self.date = 'today'

  return self
}

export default movementIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/resources/icons.resource.js